__turbopack_context__.v({
  "servicesList": "services-section-module-scss-module__um4HPa__servicesList",
  "servicesSection": "services-section-module-scss-module__um4HPa__servicesSection",
  "showAllButton": "services-section-module-scss-module__um4HPa__showAllButton",
});
